// Botón de acción principal de los modales.
// Medidas calcadas del handoff (bloque modal de "Reportes CrediApp.dc.html"):
// alto 50, radio 12, gradiente 135deg #12a35a -> #0c8a4c, Poppins 600 15px,
// gap 9 entre icono y texto, sombra 0 12px 24px -12px rgba(18,163,90,.7).
export const accionPrincipalSx = {
  width: "100%",
  height: 50,
  marginTop: "6px",
  border: "none",
  borderRadius: "12px",
  background: "linear-gradient(135deg,#12a35a,#0c8a4c)",
  color: "#fff",
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: 15,
  gap: "9px",
  boxShadow: "0 12px 24px -12px rgba(18,163,90,.7)",
  "& .MuiButton-startIcon": { marginRight: 0, marginLeft: 0, fontSize: 17 },
  "&:hover": {
    background: "linear-gradient(135deg,#0f9151,#0a7743)",
    boxShadow: "0 12px 24px -12px rgba(18,163,90,.7)",
  },
  "&.Mui-disabled": {
    background: "linear-gradient(135deg,#12a35a,#0c8a4c)",
    color: "#fff",
    opacity: 0.5,
  },
};
